import React, { useEffect, useState } from "react";
import {
  Grid,
  TextareaAutosize,
} from "@mui/material";
import TextInput from "../common/TextInput";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Modal from "../common/modal/Modal";
import ButtonComponent from "../common/button/Button";
import Dropdown from "../common/Dropdown";
import menuAllData from "../../common/confirmationSupportMenu.json";
import { toast } from "react-toastify";
import { postUserSupportTicketApi } from "../../redux/actions/userSupportTicketSlice";
import { postUserSupportTicket } from "../../common/endpoints";

const ConfirmationTicketModal = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state?.userSupportTicket?.loading);

  const [selectedMenu, setSelectedMenu] = useState("");
  const [selectedSubmenu, setSelectedSubmenu] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedFunction, setSelectedFunction] = useState("");
  const [selectedAssignedTo, setSelectedAssignedTo] = useState("");
  const [selectedUrgency, setSelectedUrgency] = useState("");
  const [description, setDescription] = useState("");
  const [menuInitialized, setMenuInitialized] = useState(false);
  const [showPreview, setShowPreview] = useState(false);

  const urgencyOptions = [
    { label: "Standard", value: "Standard", title: "Standard" },
    { label: "Urgent", value: "Urgent", title: "Urgent" },
  ];

  const [menuOptions, setMenuOptions] = useState([]);
  const [submenuOptions, setSubmenuOptions] = useState([]);
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [functionOptions, setFunctionOptions] = useState([]);
  const [assignedToOptions, setAssignedToOptions] = useState([]);

  const userEmail = localStorage.getItem("data");

  const submenuOptionsMap = {
    "Dashboard": [
      { label: "Risk Cards", value: "Risk Cards", title: "Risk Cards" },
      { label: "Filters", value: "Filters", title: "Filters" },
      { label: "Supply Risk Feed Table", value: "Supply Risk Feed Table", title: "Supply Risk Feed Table" },
    ],
    "Material Drilldown": [
      { label: "Cards", value: "Cards", title: "Cards" },
      { label: "Supplier Summary Table", value: "Supplier Summary Table", title: "Supplier Summary Table" },
      { label: "Charts", value: "Charts", title: "Charts" },
      { label: "52 Week Table", value: "52 Week Table", title: "52 Week Table" },
      { label: "Simulation feature", value: "Simulation feature", title: "Simulation feature" },
      { label: "Consider Full confirmation", value: "Consider Full confirmation", title: "Consider Full confirmation" },
      { label: "Alternate Sourcing Hyperlink", value: "Alternate Sourcing Hyperlink", title: "Alternate Sourcing Hyperlink" },
    ],
    "Supplier Drilldown": [
      { label: "Cards", value: "Cards", title: "Cards" },
      { label: "Supplier Selection menu", value: "Supplier Selection menu", title: "Supplier Selection menu" },
      { label: "Charts", value: "Charts", title: "Charts" },
      { label: "52 Week Table", value: "52 Week Table", title: "52 Week Table" },
       { label: "Manage PR", value: "Manage PR", title: "Manage PR" },
        { label: "Send to IBP", value: "Send to IBP", title: "Send to IBP" },
    ],
    
   
   
    "Parameter Configuration": [
      { label: "Sliders", value: "Sliders", title: "Sliders" },
      { label: "Save Button", value: "Save Button", title: "Save Button" },
      { label: "Reset to default ", value: "Reset to default ", title: "Reset to default " },
      { label: "Exception rule", value: "Exception rule", title: "Exception rule" },
      { label: "Operational override table", value: "Operational override table", title: "Operational override table" },
    ],
    "SAP IBP Sync Status": [
      { label: "Retry", value: "Retry", title: "Retry" },
      { label: "Sync Status Table", value: "Sync Status Table", title: "Sync Status Table" },
     
    ],
   
   
  };

  const getUniqueValues = (data = [], key) => {
    if (data?.length > 0) {
      const uniqueValues = [
        ...new Set(data?.map((item) => item[key]).filter(Boolean)),
      ];
      return uniqueValues?.map((value) => ({
        label: value,
        value: value,
        title: value,
      }));
    }
    return [];
  };

  const resetDependents = (from) => {
    if (from === "menu") {
      setSelectedSubmenu("");
      setSubmenuOptions([]);
      setSelectedCategory("");
      setSelectedFunction("");
      setSelectedAssignedTo("");
      setCategoryOptions([]);
      setFunctionOptions([]);
      setAssignedToOptions([]);
    } else if (from === "category") {
      setSelectedFunction("");
      setSelectedAssignedTo("");
      setFunctionOptions([]);
      setAssignedToOptions([]);
    } else if (from === "function") {
      setSelectedAssignedTo("");
      setAssignedToOptions([]);
    }
  };

  const handleSelectedItemsChange = (name, event) => {
    const value = event.target.value;

    if (name === "menu") {
      setSelectedMenu(value);
      resetDependents("menu");
      setSubmenuOptions(submenuOptionsMap[value] || []);

      const filteredCategories = menuAllData
        .filter((item) => item.menu === value)
        .map((item) => item.category);
      setCategoryOptions(
        getUniqueValues(
          filteredCategories.map((c) => ({ category: c })),
          "category"
        )
      );
    } else if (name === "category") {
      setSelectedCategory(value);
      resetDependents("category");

      const filteredItems = menuAllData.filter(
        (item) => item.menu === selectedMenu && item.category === value
      );
      const functionList = filteredItems.map((item) => item.function);
      const assignedToList = filteredItems.map((item) => item.assignedTo);

      const funcOpts = getUniqueValues(
        functionList.map((f) => ({ function: f })),
        "function"
      );
      setFunctionOptions(funcOpts);

      const assignedToOpts = getUniqueValues(
        assignedToList.map((a) => ({ assignedTo: a })),
        "assignedTo"
      );
      setAssignedToOptions(assignedToOpts);
      if (assignedToOpts.length > 0) {
        setSelectedAssignedTo(assignedToOpts[0].value);
      }
    } else if (name === "function") {
      setSelectedFunction(value);

      // Resolve assignedTo from the matching row
      const matchedItem = menuAllData.find(
        (item) =>
          item.menu === selectedMenu &&
          item.category === selectedCategory &&
          item.function === value
      );
      if (matchedItem?.assignedTo) {
        setSelectedAssignedTo(matchedItem.assignedTo);
        setAssignedToOptions([
          {
            label: matchedItem.assignedTo,
            value: matchedItem.assignedTo,
            title: matchedItem.assignedTo,
          },
        ]);
      }
    } else if (name === "assignedTo") {
      setSelectedAssignedTo(value);
    }
  };

  // Path → Menu pre-selection map for GRPT routes
  const pathToMenuMap = {
   
    "/dashboard": "Dashboard",
    "/dashboard/material": "Material Drilldown",
   // "/dashboard/material/": "Supplier Drilldown",  
   
    "/parameter-configuration": "Parameter Configuration",
   
   
    "/sap-ibp-sync-status": "SAP IBP Sync Status",
  };

  const resolveMenuFromPath = (pathname) => {
    const isSupplierDrilldownPath = /^\/dashboard\/material\/[^/]+\/[^/]+\/supplier\/[^/]+\/?[^/]*\/?$/.test(pathname);
    if (isSupplierDrilldownPath) {
      return "Supplier Drilldown";
    }

    const matchedEntry = Object.entries(pathToMenuMap)
      .sort((a, b) => b[0].length - a[0].length)
      .find(([path]) => pathname === path || pathname.startsWith(`${path}/`));

    return matchedEntry?.[1] || "";
  };

  useEffect(() => {
    if (!menuInitialized) {
      const uniqueMenus = getUniqueValues(menuAllData, "menu");
      setMenuOptions(uniqueMenus);

      const matchedMenu = resolveMenuFromPath(location.pathname);
      if (matchedMenu) {
        setSelectedMenu(matchedMenu);
        setSubmenuOptions(submenuOptionsMap[matchedMenu] || []);
        const filteredCategories = menuAllData
          .filter((item) => item.menu === matchedMenu)
          .map((item) => item.category);
        setCategoryOptions(
          getUniqueValues(
            filteredCategories.map((c) => ({ category: c })),
            "category"
          )
        );
      }
      setMenuInitialized(true);
    }
    setMenuInitialized(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, menuInitialized]);

  const resetForm = () => {
    setSelectedMenu("");
    setSelectedSubmenu("");
    setSelectedCategory("");
    setSelectedFunction("");
    setSelectedAssignedTo("");
    setSelectedUrgency("");
    setDescription("");
    setCategoryOptions([]);
    setFunctionOptions([]);
    setAssignedToOptions([]);
    setMenuInitialized(false);
    setShowPreview(false);
  };

  const handleClose = () => {
    resetForm();
    props.handleClose();
  };

  const isSubmitEnabled =
    selectedMenu &&
    selectedCategory &&
    selectedUrgency &&
    description.trim();

  const handlePreview = () => {
    setShowPreview(true);
  };

  const submitTicketHandler = async () => {
    const requestBody = {
      menu: selectedMenu,
      submenu: submenuOptions.length === 0 ? selectedMenu : selectedSubmenu || "",
      category: selectedCategory,
      urgency: selectedUrgency,
      issueDescription: description,
      assignedTo: "AFC Team",
      userEmail: userEmail,
    };

    try {
      const response = await dispatch(
        postUserSupportTicketApi({
          dynamicEndpoint: postUserSupportTicket,
          data: requestBody,
        })
      );

      if (response?.meta?.requestStatus === "fulfilled") {
        toast.success(
          `Ticket created successfully. Please visit 'Ticket Summary' for more details.`,
          { autoClose: 3000 }
        );
        if (response?.payload?.alIdentifier) {
          toast.info(`AL Identifier: ${response.payload.alIdentifier}`, {
            autoClose: 7000,
            position: "bottom-center",
          });
        }
        handleClose();
      } else {
        toast.error(
          response?.payload?.errorMessage || "Failed to create ticket.",
          { autoClose: 3000 }
        );
      }
    } catch (error) {
      console.error("API error:", error);
    }
  };

  return (
    <Modal
      open={props.showModal}
      handleClose={handleClose}
      title={props.title}
      fullWidth={true}
      maxWidth="md"
      content={
        <>
          {showPreview ? (
            <>
              <div style={{ fontWeight: 500, fontSize: 15, marginBottom: 8 }}>Preview</div>
              <div style={{ border: '1px solid #ddd', borderRadius: 6, padding: '16px', boxSizing: 'border-box' }}>
                {[
                  { label: "Menu", value: selectedMenu },
                  { label: "Submenu", value: submenuOptions.length === 0 ? selectedMenu : selectedSubmenu || "-" },
                  { label: "Category", value: selectedCategory },
                  { label: "Priority", value: selectedUrgency },
                  { label: "Assigned To", value: selectedAssignedTo || "-" },
                  { label: "Issue Description", value: description },
                ].map(({ label, value }) => (
                  <div key={label} style={{ display: 'flex', marginBottom: 10 }}>
                    <span style={{ fontWeight: 700, fontSize: 13, minWidth: 140, flexShrink: 0 }}>{label}</span>
                    <span style={{ fontSize: 13, whiteSpace: 'pre-wrap' }}>: &nbsp;{value}</span>
                  </div>
                ))}
              </div>
            </>
          ) : (
          <>
          {/* Row 1: Dropdowns */}
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              md={3}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <label className="label-position" htmlFor="grpt-menu">
                Menu
              </label>
              <Dropdown
                maxWidth="100%"
                value={selectedMenu || ""}
                name="menu"
                options={menuOptions}
                handleChange={(event) =>
                  handleSelectedItemsChange("menu", event)
                }
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={3}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <label className="label-position" htmlFor="grpt-submenu">
                Submenu
              </label>
              <Dropdown
                maxWidth="100%"
                value={selectedSubmenu || ""}
                name="submenu"
                options={submenuOptions}
                disabled={!selectedMenu}
                handleChange={(event) => setSelectedSubmenu(event.target.value)}
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={3}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <label className="label-position" htmlFor="grpt-category">
                Category
              </label>
              <Dropdown
                maxWidth="100%"
                value={selectedCategory || ""}
                name="category"
                options={categoryOptions}
                disabled={!selectedMenu}
                handleChange={(event) =>
                  handleSelectedItemsChange("category", event)
                }
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={3}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              {/*}
              <label className="label-position" htmlFor="grpt-function">
                Function
              </label>
              <Dropdown
                maxWidth="100%"
                value={selectedFunction || ""}
                name="function"
                options={functionOptions}
                disabled={!selectedCategory}
                handleChange={(event) =>
                  handleSelectedItemsChange("function", event)
                }
              />
              */}
            </Grid>

            <Grid
              item
              xs={12}
              md={3}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <label className="label-position" htmlFor="grpt-urgency">
                Urgency
              </label>
              <Dropdown
                maxWidth="100%"
                value={selectedUrgency || ""}
                name="urgency"
                options={urgencyOptions}
                handleChange={(event) => setSelectedUrgency(event.target.value)}
              />
            </Grid>

            <Grid
              item
              xs={12}
              md={3}
              sx={{ display: "flex", flexDirection: "column" }}
            >
              <label className="label-position" htmlFor="grpt-assignedTo">
                Assigned To
              </label>
              <Dropdown
                maxWidth="100%"
                value={selectedAssignedTo || ""}
                name="assignedTo"
                options={assignedToOptions}
                disabled={!selectedFunction}
                handleChange={(event) =>
                  handleSelectedItemsChange("assignedTo", event)
                }
              />
            </Grid>
          </Grid>

          {/* Row 2: Issue Description */}
          <Grid container mt={2}>
            <Grid item xs={12}>
              <TextareaAutosize
                minRows={6}
                placeholder="Issue Description"
                style={{ width: "100%", boxSizing: "border-box" }}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </Grid>
          </Grid>
          </>
          )}
        </>
      }
      action={
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            margin: "8px 0",
          }}
        >
          {/* Left: Initiator */}
          <div style={{ flex: "0 0 250px" }}>
            <TextInput
              label="Initiator"
              value={userEmail || ""}
              disabled={true}
              width="250px"
            />
          </div>

          {/* Right: Cancel / Submit or Back / Create Ticket */}
          <div style={{ display: "flex", gap: 10, flexShrink: 0 }}>
            {showPreview ? (
              <>
                <ButtonComponent
                  maxWidth="120px"
                  label="Back"
                  bgColor="white"
                  color="black"
                  onClick={() => setShowPreview(false)}
                />
                <ButtonComponent
                  maxWidth="140px"
                  bgColor="black"
                  color="white"
                  label={isLoading ? "Submitting..." : "Create Ticket"}
                  disabled={isLoading}
                  onClick={submitTicketHandler}
                />
              </>
            ) : (
              <>
                <ButtonComponent
                  maxWidth="120px"
                  label="Cancel"
                  bgColor="white"
                  color="black"
                  onClick={handleClose}
                />
                <ButtonComponent
                  maxWidth="120px"
                  label="Submit"
                  bgColor="black"
                  color="white"
                  disabled={!isSubmitEnabled}
                  onClick={handlePreview}
                />
              </>
            )}
          </div>
        </div>
      }
    />
  );
};

export default ConfirmationTicketModal;
